import { useCallback } from 'react';
import { getDefaultAnalyticsTraits } from 'helpers/analytics';

const useRudderStackTrack = () => useCallback(trackRudderstackEvent, []);

/**
 * Exporting a non-hook from a hook file is not ideal, but it keeps the logic close to the hook.
 */
export const trackRudderstackEvent = (eventName: string, properties = {}) => {
  // @ts-ignore
  window.rudderanalytics?.track(eventName, {
    ...getDefaultAnalyticsTraits(),
    ...properties,
  });
};

export default useRudderStackTrack;
